import axios from "axios";
import { baseUrl, portal } from "../App";

export const fetchSubscriptionUrl = async (token, service_type) => {
  const searchParams = new URLSearchParams(window.location.search);
  const paramsObject = Object.fromEntries(searchParams);

  const config = {
    headers: { Authorization: `Token ${token}` },
  };

  sessionStorage.setItem("subscriptionServiceType", service_type)
  const res = await axios
    .post(
      `${baseUrl}/api/v1/telco/payment/bl/subscription/create/`,
      { portal: portal, qcid: sessionStorage.getItem("cid"), "service_type": service_type, ...paramsObject },
      config
    )
  return res.data;
}